module.exports = __webpack_public_path__ + "img/m2_t1_bg.284f20b0.svg";